export const en = {
    "wallet.auth.title": "Create an e-wallet account",
    "wallet.auth.register": "Register",
    "wallet.auth.login": "Login",
    "wallet.auth.already_have": "Already have an account?",

    "auth.register.title": "Registration",
    "auth.register.first_name": "First Name",
    "auth.register.last_name": "Last Name",
    "auth.register.email": "Email",
    "auth.register.address": "Address",
    "auth.register.city": "City",
    "auth.register.country": "Country",
    "auth.register.zip_code": "Zip Code",
    "auth.register.address_section": "Address Details",
    "auth.register.continue_btn": "Continue",
    "auth.register.enter_help": "Login for registered users.",
    "auth.register.enter_code_help": "Enter the code from the message",
    "auth.register.enter_code_descr": "Enter the 4-digit code sent to your number",
    "auth.register.send_again_btn": "Send again",
    "auth.register.set_pin.help": "Set your PIN code",
    "auth.register.set_pin.descr": "Create a 4-digit PIN code for transaction confirmation",
    "auth.register.set_pin.continue": "Continue",

    "wallet.auth.login.register_link": "Registration",
    "wallet.auth.login.login": "Login to your account",
    "wallet.auth.login.sms_help": "You will receive an SMS with a confirmation code to log into your account.",
    "wallet.auth.login.new_help": "Registration for new users.",
    "wallet.auth.login.send_code": "Send code",
    "wallet.auth.login.enter_code": "Enter the code from the message",
    "wallet.auth.login.enter_code_descr": "Enter the 4-digit code sent to your number",
    "wallet.auth.login.enter_btn": "Login",
    "wallet.auth.login.sms_repeat": "Send again",
    "wallet.auth.change_number": "Change number",

    "phone_input.phone": "Phone number",
    "phone_input.phone.default_country.name": "United Kingdom",
    "phone_input.phone.default_country.code": "+44",
    "phone_input.phone.default_country.iso": "GB",
    "phone_input.phone.default_country.flag": "https://cdn.kcak11.com/CountryFlags/countries/gb.svg",
    "phone_input.phone.default_country.mask": "#########",

    "menu.home": "Home",
    "menu.wallet": "Wallet",
    "menu.payment": "Payment",
    "menu.history": "History",
    "menu.settings": "Account",

    "header.welcome.greetings": "Welcome",
    "header.welcome.subtitle": "Have a nice day",

    "notifications.title": "Notifications",
    "notifications.close_btn": "Close",

    "qr_payment.title": "Pay using QR code",
    "qr_payment.description": "Now you can transfer funds simply by pointing your camera at the QR code",

    "qr_payment.not_avaliable.title": "QR code payment is temporarily unavailable,",
    "qr_payment.not_avaliable.subtitle": "we apologize for any inconvenience caused.",
    "qr_payment.your_qr": "Your QR code",
    "qr_payment.scan_qr": "Scan",

    "payment.topup_btn": "Top up",
    "payment.exchange_btn": "Exchange",    
    "payment.withdrawal_btn": "Withdraw",
    "payment.topup.not_avaliable": "Withdrawals are unavailable, please complete identification.",
    "payment.withdrawal.not_avaliable": "Wallet top-up is unavailable, please complete identification.",
    "payment.send_btn": "Send",
    "payment.qr_file_upload": "Drag and drop or select QR-code file",
    "payment.qr_file_upload_extensions": "Allowed formats: png, jpg",

    "wallet_save.send_btn": "Send",

    "transactions.title": "Transactions",
    "transactions.list.operation": "operation",
    "transactions.list.withdrawal": "withdrawal",
    "transactions.list.topup": "top-up",
    "transactions.list.empty_descr": "Make your first payment, and your transactions will appear here.",

    "account.create_btn": "+ Add account",
    "account.create_new_btn": "+ Add new account",

    "history.title": "History",

    "profile.title": "Account Information",
    "profile.email": "E-mail:",
    "profile.phone": "Phone",
    "profile.register_date": "Registration date",
    "profile.logout": "Logout",

    "profile.identification.title": "Verification",
    "profile.identification.level.title": "Current level",
    "profile.identification.upgrade.status": "Upgrade status",
    "profile.identification.upgrade_btn": "upgrade",
    "profile.identification.refresh_status_btn": "refresh status",
    "profile.identification.retry_upgrade_btn": "retry identification",

    "profile.qr.title": "This is your QR code",
    "profile.qr.share": "Share your code to receive payments",
    "profile.qr.download": "Download QR code",

    "select_currency.text": 'Выберете валюту',

    "policy.title": "Legal",

    "exchange.index.title": 'Exchange',
    "exchange.index.submit_btn": 'exchange',        
    "exchange.from": 'from',
    "exchange.to": 'to',
    "exchange.current_balance": 'balance:',    
    "exchange.index.no_rate": 'No rate',
    "exchange.index.success_message": 'Exchange successfully completed!',
    "exchange.index.not_available": 'Exchange is not available for your account',

    "wallet_topup.select_account": "Select account",
    "wallet_topup.amount": "Amount",
    "wallet_topup.top_up": "Top up",
    "wallet_topup.accept_the": "I accept the",
    "wallet_topup.terms_of_use": "Terms of Use",
    "wallet_topup.success": "Success",
    "wallet_topup.error": "Top-up is temporarily unavailable. Please try again later.",

    "wallet_withdrawal.select_account": "Select account",
    "wallet_withdrawal.amount": "Amount",
    "wallet_withdrawal.card": "Card",
    "wallet_withdrawal.success_message": "Withdrawal request successfully created!",
    "wallet_withdrawal.withdrawal_btn": "Withdraw",
    "wallet_withdrawal.usdc_etc_address": "ETC address",

    "select_exchange.select_account": "Select account",
    "select_exchange.from": "From",
    "select_exchange.to": "To",
    "select_exchange.search_placeholder": "Search",


    "history.category.default": "default",

    "pay_modal.enter_pin": "Enter pin code",
    "pay_modal.enter_pin_description": "For confirmation of the transfer, enter your pin code",
    "pay_modal.waiting": "Waiting",
    "pay_modal.waiting_description": "Do not close the page",
    "pay_modal.try_again": "Try again",
}
